import { isEnabled } from "lib/@components/feature"
import { registerTab } from "lib/@components/tabs"
import { REVIEW_TABS } from "routes/plan/review-tabs"
import { FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/server/feature-flag-tailored-schedule-auditing.mjs"
import { TailoredSchedulesRegimeTab, TailoredSchedulesRegimeTabWrapper } from "../../tailored-schedules-regime-tab"
import { isTailoredScheduleAuditingEnabled } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/lib/is-tailored-schedule-auditing-enabled"
import { TailoredTabAuditing } from "./tailored-tab-auditing"
import { Divider } from "@mui/material"

registerTab({
    tab: REVIEW_TABS,
    id: "review-tailoring",
    title: "Tailored",
    predicate: () => isEnabled(FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING),
    content: <TailoredSchedulesRegimeTab prefix="publish|" priority={160} />,
})

//Register a vertical bar spacer
registerTab({
    tab: REVIEW_TABS,
    id: "review-tailoring_spacer",
    tabProps: { disabled: true },
    title: <Divider orientation="vertical" />,
    predicate: () => isEnabled(FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING),
    content: <TailoredSchedulesRegimeTab prefix="publish|" priority={150} />,
})

TailoredSchedulesRegimeTabWrapper.plug(<TailoredTabAuditing if={isTailoredScheduleAuditingEnabled} />)
